<template>
  <figure
    class="image-loader"
    :class="{
      'image-loader--loaded': hasLoaded
    }"
    :style="`padding-bottom: ${aspectRatio}%;`"
  >
    <img
      :alt="altText"
      :src="source"
      @load="loadedHandler"
    >
  </figure>
</template>



<script>
  export default {
    name: 'ImageLoader',

    props: {
      altText: {
        type: String,
        default: null
      },
      sizeX: {
        type: Number,
        default: 1440
      },
      sizeY: {
        type: Number,
        default: 600
      },
      source: {
        type: String,
        required: true
      }
    },

    data() {
      return {
        hasLoaded: false
      };
    },

    computed: {
      aspectRatio() {
        return 100 / (this.sizeX / this.sizeY);
      }
    },

    methods: {
      loadedHandler() {
        this.hasLoaded = true;
      }
    }
  };
</script>
